import ng from 'angular';
import { IColaboradorWorkflow } from '../../models/workflow.colaborador.model';
import { IWorkflowAcao } from '../../models/workflow.acao.model';

export class WorkflowDynamicModalService {
    static $inject = [
        '$uibModal'
    ];

    constructor(
        private $uibModal: ng.ui.bootstrap.IModalService,
    ) { }

    public open(acao: IWorkflowAcao, trabalhador: IColaboradorWorkflow): ng.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./workflow.dynamic.html'),
            controller: 'WorkflowDynamicModalController',
            controllerAs: 'ctrl_modal',
            backdrop: 'static',
            resolve: {
                acao: () => acao,
                trabalhador: () => trabalhador
            }
        });
    }
}
